import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const DELETE_QUERY = print(gql`
  mutation DeleteTag($id: Int!) {
    deleteTag(id: $id) {
      id
    }
  }
`);

export interface DeleteGql {
  deleteTag: {
    id?: number;
  };
}
